import { BOOKING_INFO } from "@/content/bookingInfo";
import { Check } from "lucide-react";

interface BookingInfoSectionProps {
  slug: keyof typeof BOOKING_INFO | string;
}

export const BookingInfoSection = ({ slug }: BookingInfoSectionProps) => {
  const content = BOOKING_INFO[slug as keyof typeof BOOKING_INFO];
  if (!content) return null;

  return (
    <section
      aria-label="Property information"
      className="mt-8 md:mt-12 px-4 md:px-0"
    >
      <div className="md:bg-white/10 md:backdrop-blur-md md:border md:border-white/20 md:rounded-2xl p-4 md:p-8 lg:p-10 md:shadow-xl text-white">
        <h2 className="font-display text-2xl md:text-3xl font-bold mb-4 md:mb-6">
          {content.heading}
        </h2>

        <div className="space-y-4 text-white/90 leading-relaxed text-sm md:text-base">
          {content.overview.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-10 mt-8">
          <div>
            <h3 className="font-display text-lg md:text-xl font-semibold mb-3 text-accent">
              What's included
            </h3>
            <ul className="space-y-2 text-sm md:text-base text-white/90">
              {content.included.map((item) => (
                <li key={item} className="flex gap-2">
                  <Check className="w-4 h-4 mt-1 flex-shrink-0 text-accent" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-5 text-sm md:text-base text-white/90 leading-relaxed">
            <div>
              <h3 className="font-display text-lg md:text-xl font-semibold mb-2 text-accent">
                Getting here & parking
              </h3>
              <p>{content.gettingHere}</p>
            </div>
            <div>
              <h3 className="font-display text-lg md:text-xl font-semibold mb-2 text-accent">
                Plan your day
              </h3>
              <p>{content.planYourDay}</p>
            </div>
          </div>
        </div>

        <div className="mt-8">
          <h3 className="font-display text-lg md:text-xl font-semibold mb-4 text-accent">
            Frequently asked questions
          </h3>
          <div className="space-y-4">
            {content.faqs.map((f) => (
              <div key={f.q}>
                <p className="font-semibold text-white">{f.q}</p>
                <p className="text-white/80 text-sm md:text-base mt-1">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingInfoSection;
